"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LacerateAbilityHandler = exports.LacerateActorAbilityFactory = exports.LacerateAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Bleeding_1 = require("../../core/effects/core/Bleeding");
const Registries_1 = require("../../core/state/Registries");
const EffectType_1 = require("../../core/effects/EffectType");
class LacerateAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Lacerate;
        this.__typeName = "Lacerate";
    }
}
exports.LacerateAbilityArgs = LacerateAbilityArgs;
let LacerateActorAbilityFactory = class LacerateActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Lacerate", "OneEnemies", 3);
    }
};
LacerateActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Lacerate")
], LacerateActorAbilityFactory);
exports.LacerateActorAbilityFactory = LacerateActorAbilityFactory;
let LacerateAbilityHandler = class LacerateAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        let power = 80;
        if (container.hasAttribute(ability.invokerId, "Charm_Assassin_1") && container.hasEffectOfType(selectedEnemy, EffectType_1.EffectType.LikeABoss)) {
            power = 160;
        }
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", power)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: selectedEnemy,
                    duration: Duration_1.Duration.Ticks(8),
                    effect: new Bleeding_1.BleedingEffectArgs("Power", 10)
                });
            }
        });
    }
};
LacerateAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Lacerate)
], LacerateAbilityHandler);
exports.LacerateAbilityHandler = LacerateAbilityHandler;
